import { IDurationPeriods, IRequiredDurationValues } from '../interfaces';
import { Period } from '../enums';

const periodsExtract = [
    [Period.YEAR, 86400 * 365],
    [Period.MONTH, 86400 * 30],
    [Period.WEEK, 604800],
    [Period.DAY, 86400],
    [Period.HOUR, 3600],
    [Period.MINUTE, 60],
    [Period.SECOND, 1],
];

/**
 * Periods multiplier constant
 */
const multiplier = [1, 12, 4.3482, 7, 24, 60, 60];

/**
 * Calculate time left for H M S periods
 */
export const calculatePeriods = (
    endTime: number,
    currentTime: number,
    requiredDurationValues: IRequiredDurationValues,
): IDurationPeriods => {
    const periods = [0, 0, 0, 0, 0, 0, 0];
    let diff = Math.max(0, Math.floor((endTime - currentTime) / 1000));

    diff = periodsExtract.reduce((finalValue, [period, seconds]) => {
        periods[period] = requiredDurationValues[period] ? Math.floor(finalValue / seconds) : 0;
        return finalValue - periods[period] * seconds;
    }, diff);

    if (diff > 0) {
        // Round up if left overs
        let lastShown = Period.SECOND;
        let max = 1;
        for (let period = Period.SECOND; period >= Period.YEAR; period--) {
            if (requiredDurationValues[period]) {
                if (periods[lastShown] >= max) {
                    periods[lastShown] = 0;
                    diff = 1;
                }

                if (diff > 0) {
                    periods[period]++;
                    diff = 0;
                    lastShown = period;
                    max = 1;
                }
            }

            max *= multiplier[period];
        }
    }

    return periods;
};
